import request from '@/shared/apis'

const getBaseApiUrl = () => {
  return '/evaluations/documents';
};

const getDocumentApiUrl = (documentId) => {
  return `${getBaseApiUrl()}/${documentId}`;
};

/**
 * Create a new evaluation document template
 * @param {File} file - Word template file (.docx) with {{fieldCode}} placeholders
 * @param {string} documentName - Name for the document
 * @param {number} templateId - Evaluation template ID
 * @returns {Promise} Created document object
 */
export const createEvaluationDocument = async (file, documentName, templateId) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('documentName', documentName);
  formData.append('template', templateId);

  return await request.post(getBaseApiUrl(), formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

/**
 * Get evaluation document by ID
 * @param {number} documentId - Document ID
 * @returns {Promise} Document object
 */
export const getEvaluationDocument = async (documentId) => {
  return await request.get(getDocumentApiUrl(documentId));
};

/**
 * Delete evaluation document
 * @param {number} documentId - Document ID
 * @returns {Promise} void
 */
export const deleteEvaluationDocument = async (documentId) => {
  return await request.delete(getDocumentApiUrl(documentId));
};

/**
 * Get all documents for an evaluation template
 * @param {number} templateId - Evaluation template ID
 * @returns {Promise} Array of document objects
 */
export const getDocumentsByTemplate = async (templateId) => {
  return await request.get(`${getBaseApiUrl()}/template/${templateId}`);
};

/**
 * Download evaluation document as PDF
 * Replaces {{fieldCode}} placeholders with actual evaluation responses
 * @param {number} documentId - Document template ID
 * @param {number} evaluationId - Evaluation instance ID
 * @returns {Promise<Blob>} PDF file blob
 */
export const downloadEvaluationDocument = async (documentId, evaluationId) => {
  return await request.get(`${getDocumentApiUrl(documentId)}/download`, {
    params: { evaluation: evaluationId },
    responseType: 'blob'
  });
};

export default {
  createEvaluationDocument,
  getEvaluationDocument,
  deleteEvaluationDocument,
  getDocumentsByTemplate,
  downloadEvaluationDocument
};
